const eventHandler = ({ response, queryClient }) => {
  const data = response?.data;
  const eventType = JSON.parse(data)?.type;

  switch (eventType) {
    case 'helpRequestCancelled':
      queryClient.invalidateQueries({ queryKey: ['help-request-operator-status'] });
      queryClient.invalidateQueries({ queryKey: ['help-request-status'] });
      break;
    case 'newHelpRequest':
    case 'helpRequestAcceptedByOther':
      queryClient.invalidateQueries({ queryKey: ['help-request-operator-status'] });
      break;
    case 'helpRequestAccepted':
    case 'helpRequestRefetch':
      queryClient.invalidateQueries({ queryKey: ['help-request-status'] });
      break;
    case 'helpRequestCompleted':
      window.location.href = '/host';
      break;
    case 'host-stock':
      window.dispatchEvent(new CustomEvent('host-stock-refetch'));
      break;
    case 'updateActiveOperator':
      queryClient.invalidateQueries({ queryKey: ['active-operators'] });
      break;
    default:
      break;
  }
};

export default eventHandler;
